.sectionTitle {
  margin-top: 16px;
  margin-bottom: 16px;
}

.description {
  margin-bottom: 24px;
}

.table {
  margin-bottom: 16px;
}

.urlCell {
  display: flex;
  align-items: center;
  gap: 4px;
}

.urlText {
  overflow: hidden;
  text-overflow: ellipsis;
}

.noItems {
  margin-bottom: 16px;
}

.formRow {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-end;
  margin-bottom: 16px;
}

.nameField {
  flex: 1;
}

.urlField {
  flex: 2;
}
